module.exports = __webpack_public_path__ + "img/22.71eda770.png";